import React from "react";
import styled from "styled-components";
import logoWhiteImage from "../../assets/Logodarkbg@2x.png";
import logoDarkImage from "../../assets/Logo@2x.png";
import logoTealImage from "../../assets/LogoTeal@2x.png";

const logoSourceMap = {
  dark: logoDarkImage,
  teal: logoTealImage,
  white: logoWhiteImage
};

const Logo = styled.img`
  height: 1.6rem;
  cursor: pointer;
`;

export default ({ color = "dark" }) => <Logo src={logoSourceMap[color]} />;



// WEBPACK FOOTER //
// ./src/components/Logo.js